// extracted by mini-css-extract-plugin
export var tickerWrap = "LogosTicker-module--tickerWrap--3uHdr";
export var ticker = "LogosTicker-module--ticker--1MW80";
export var ticker__headline = "LogosTicker-module--ticker__headline--2Wmk3";